export const ROUTE_PATH = {
  HOME: '/',
  LOGIN: '/login',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_SUCCESS: '/reset-password-successfully',
  MEMBER_MANAGEMENT: '/member-management',
  ADMIN_REGISTER: '/admin-register',
  NEWS_MANAGEMENT: '/news-management',
  COURSE_MANAGEMENT: '/course-management',
  COURSE_SCHEDULE: '/course-schedule',
  FESTIVAL_MANAGEMENT: '/festival-management',
  FAQ_MANAGEMENT: '/faq-management',
  STUDIO_MANAGEMENT: '/studio-management',
  SEMINAL_MANAGEMENT: '/seminal-management',
  EVENT_MANAGEMENT: '/event-management',
  COLLECTION_MANAGEMENT: '/collection-management',
  BRUSH_UP_SEMINAR: '/brush-up-seminar',
  NEW_STUDENT_REGISTER: '/new-student-register',
  STUDENT_RETAKETATION: '/student-retaketation',
  CEU_MANAGEMENT: '/ceu-management',
  EDITOR_MANAGEMENT: '/editor-management',
};
